import type { IssueTypeStatus } from "@overmap-ai/common"

import { FilterModifier } from "./FilterModifier"

export const IssueTypeStatusEqualsFilterModifier = FilterModifier.create<
	IssueTypeStatus["uuid"],
	IssueTypeStatus["uuid"]
>({
	id: "issue-type-status-equals",
	getApplyFn: (filterValue) => (value) => {
		return value === filterValue
	},
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const IssueTypeStatusNotEqualsFilterModifier = FilterModifier.create<
	IssueTypeStatus["uuid"],
	IssueTypeStatus["uuid"]
>({
	id: "issue-type-status-not-equals",
	getApplyFn: (filterValue) => (value) => {
		return value !== filterValue
	},
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const IssueTypeStatusIncludesFilterModifier = FilterModifier.create<
	IssueTypeStatus["uuid"],
	IssueTypeStatus["uuid"][]
>({
	id: "issue-type-status-includes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return filterValueSet.has(value)
		}
	},
	render: () => "is any of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const IssueTypeStatusExcludesFilterModifier = FilterModifier.create<
	IssueTypeStatus["uuid"],
	IssueTypeStatus["uuid"][]
>({
	id: "issue-type-status-excludes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return !filterValueSet.has(value)
		}
	},
	render: () => "is none of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})
